<template>
  <div class="videos bg-white h-full">

    <FilterBar @searchChanged="setSearchValue">
      <template v-slot:filter>
        <div>
        </div>
        <div>

        </div>
      </template>
    </FilterBar>

    <div class="w-11/12 mx-auto">
      <VideoList v-if="typeSelected != undefined" :searchValue="search" :hasAccess="hasMaxWhitlockAccess"  :type="typeSelected"></VideoList>

      </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";

const VideoList = () => import("@/components/library/TheVideoList.vue");
const FilterBar = () => import("@/components/FilterBarNavigation.vue");

export default {
  name: "videos",
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    hasMaxWhitlockAccess() {
      return this.currentAccess.maxWhitlockAccess
    },
  },
  data() {
    return {
      loading: true,
      errored: false,
      search: "",
      typeSelected: undefined,
    };
  },
  watch: {
    $route (to, from){
     if (to.params.type != from.params.type) {
      this.parseType()
     }
    }
  },
  created() {
   this.parseType()
  },
  mounted() {
  },
  methods: {
    parseType() {
      let typeValue = "maxw_" + this.$route.params.type
      this.typeSelected =  { value: typeValue , name: typeValue  }  
    },
    setSearchValue(value) {
      this.search = value
    },
  },
  components: {
    VideoList,
    FilterBar,
  },
};
</script>

<style>
i.icon {
  font-size: 18px;
  padding-left: 4px;
  padding-top: 4px;
}
</style>
